"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLoggerBuilder = getLoggerBuilder;
exports.getLogger = getLogger;

var _ConsoleLogger = require("./ConsoleLogger");

var _LoggerBuilder = require("./LoggerBuilder");

/**
 * Build a customized logger instance
 */
function getLoggerBuilder() {
  return new _LoggerBuilder.LoggerBuilder(_ConsoleLogger.buildConsoleLogger);
}
/**
 * Get a default logger instance without any configuration
 */


function getLogger() {
  return getLoggerBuilder().build();
}
//# sourceMappingURL=index.js.map